<template>
  <el-dialog :title="$t('single.网络状态')" v-bind="$attrs" class="dialog-dark setting-dialog" v-on="$listeners">
    <div class="netstatus-container">
      <ul class="netstatus-list">
        <p>{{ $t('single.视频发送') }}</p>
        <li v-for="item in videoNetData" :key="item.key">
          <span> {{ $t(`single.${item.name}`) }}：&nbsp;{{ item.value }} {{ item.unit }}</span>
        </li>
      </ul>
      <ul class="netstatus-list">
        <p>{{ $t('single.音频发送') }}</p>
        <li v-for="item in audioNetData" :key="item.key">
          <span>{{ $t(`single.${item.name}`) }}：&nbsp;{{ item.value }} {{ item.unit }}</span>
        </li>
      </ul>
      <ul v-if="Subscription">
        <ul class="netstatus-list">
          <p>{{ $t('single.视频接收') }}</p>
          <li v-for="item in resVideoNetData" :key="item.key">
            <span>{{ $t(`single.${item.name}`) }}：&nbsp;{{ item.value }} {{ item.unit }}</span>
          </li>
        </ul>
        <ul class="netstatus-list">
          <p>{{ $t('single.音频接收') }}</p>
          <li v-for="item in resAudioNetData" :key="item.key">
            <span>{{ $t(`single.${item.name}`) }}：&nbsp;{{ item.value }} {{ item.unit }}</span>
          </li>
        </ul>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "single",
  computed: {
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    publication() {
      let pubLocallication = null;
      if (
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal &&
        this.rtcClient.RTCRoom.webrtc.publishLocal.publication
      ) {
        pubLocallication =
          this.rtcClient.RTCRoom.webrtc.publishLocal.publication;
      }
      return pubLocallication;
    },
    liveStream() {
      if (this.rtcClient.RTCRoom) {
        return this.rtcClient.RTCRoom.remoteMixStream.find((info) => {
          return info.id.split("-")[1] == "live2";
        });
      } else {
        return null;
      }
    },
    Subscription() {
      return this.$store.getters.liveSubscription;
    },
  },
  watch: {
    $attrs: {
      handler(value) {
        console.log(value);
        if (!value.visible) {
          this.closeSet();
        } else {
          this.init();
        }
      },
    },
  },
  data() {
    return {
      timer: null,
      videoNetData: [
        { name: '速率', key: "speedRate", value: null, unit: "kbps" },
        { name: '发送包', key: "packetsSent", value: null, unit: null },
        { name: '丢包', key: "nackCount", value: null, unit: null },
        { name: '丢包率', key: "lostpacketrate", value: null, unit: "%" },
        { name: '分辨率', key: "frameHeight", value: null, unit: null },
        { name: '帧率', key: "framesPerSecond", value: null, unit: null },
        {
          name: '编解码',
          key: "encoderImplementation",
          value: null,
          unit: null,
        },
      ],
      audioNetData: [
        { name: '速率', key: "speedRate", value: null, unit: "kbps" },
        { name: '发送包', key: "packetsSent", value: null, unit: null },
        { name: '丢包', key: "nackCount", value: null, unit: null },
        { name: '丢包率', key: "lostpacketrate", value: null, unit: "%" },
        { name: '编解码', key: "googCodecName", value: null, unit: null },
      ],
      resVideoNetData: [
        { name: '速率', key: "speedRate", value: null, unit: "kbps" },
        { name: '接收包', key: "packetsReceived", value: null, unit: null },
        { name: '丢包', key: "nackCount", value: null, unit: null },
        { name: '丢包率', key: "lostpacketrate", value: null, unit: "%" },
        { name: '分辨率', key: "frameHeight", value: null, unit: null },
        { name: '帧率', key: "framesPerSecond", value: null, unit: null },
        // { name: "编解码", key: "encoderImplementation", value: null },
      ],
      resAudioNetData: [
        { name: '速率', key: "speedRate", value: null, unit: "kbps" },
        { name: '接收包', key: "packetsReceived", value: null, unit: null },
        { name: '丢包', key: "nackCount", value: null, unit: null },
        { name: '丢包率', key: "lostpacketrate", value: null, unit: "%" },
        // { name: "编解码", key: "googCodecName", value: null },
      ],
      sendLocalStatus: null,
      receiveStatus: null,
      sendLocalPacketList: {
        video: [],
        audio: [],
      },
    };
  },
  beforeDestroy() {
    this.closeSet();
  },
  methods: {
    init() {
      this.closeSet();
      this.timer = setInterval(async () => {
        let sendLocalStatus = await this.rtcClient.RTCRoom.getSendStatus(
          "local"
        );
        if (this.sendLocalStatus) {
          if (
            this.sendLocalStatus &&
            this.sendLocalStatus.video &&
            sendLocalStatus.video
          ) {
            var videospeedRate = null;
            if (sendLocalStatus.video.bytesSent) {
              videospeedRate = parseInt(
                ((sendLocalStatus.video.bytesSent -
                  this.sendLocalStatus.video.bytesSent) /
                  1024) *
                8
              );
              if (videospeedRate <= 0) {
                videospeedRate = 0;
              }
            }
            if (
              sendLocalStatus.video.packetsLost &&
              sendLocalStatus.video.packetsSent &&
              sendLocalStatus.video.googNacksReceived
            ) {
              let packetTotal = Number(sendLocalStatus.video.packetsSent);
              var packetLocalVideoLost = Number(
                sendLocalStatus.video.googNacksReceived
              );
              packetLocalVideoLost =
                packetLocalVideoLost < 0 ? 0 : packetLocalVideoLost;
              this.sendLocalPacketList.video.push({
                packetsLost: packetLocalVideoLost,
                allpacket: packetTotal,
              });
              let parketListLength = this.sendLocalPacketList.video.length;
              let recentlyPacketLost =
                this.sendLocalPacketList.video[parketListLength - 1]
                  .packetsLost - this.sendLocalPacketList.video[0].packetsLost;
              let recentlyAllPacket =
                this.sendLocalPacketList.video[parketListLength - 1].allpacket -
                this.sendLocalPacketList.video[0].allpacket;
              var videolostpacketrate = parseInt(
                (recentlyPacketLost / recentlyAllPacket) * 100
              );
              if (videolostpacketrate <= 0) {
                videolostpacketrate = 0;
              } else if (videolostpacketrate > 100) {
                videolostpacketrate = 100;
              }
              if (this.sendLocalPacketList.video.length > 20) {
                this.sendLocalPacketList.video.splice(0, 1);
              }
            }
          }
          if (
            this.sendLocalStatus &&
            this.sendLocalStatus.audio &&
            sendLocalStatus.audio
          ) {
            var audiospeedRate = null;
            if (this.sendLocalStatus.audio.bytesSent) {
              audiospeedRate = parseInt(
                ((sendLocalStatus.audio.bytesSent -
                  this.sendLocalStatus.audio.bytesSent) /
                  1024) *
                8
              );
              if (audiospeedRate <= 0) {
                audiospeedRate = 0;
              }
            }
            var audiolostpacketrate = null;
            if (
              sendLocalStatus.audio.packetsLost &&
              sendLocalStatus.audio.packetsSent
            ) {
              let packetAudioTotal = Number(sendLocalStatus.audio.packetsSent);
              let packetAudioLost = Number(sendLocalStatus.audio.packetsLost);
              this.sendLocalPacketList.audio.push({
                packetsLost: packetAudioLost,
                allpacket: packetAudioTotal,
              });
              let parketAudioListLength = this.sendLocalPacketList.audio.length;
              let recentlyPacketAudioLost =
                this.sendLocalPacketList.audio[parketAudioListLength - 1]
                  .packetsLost - this.sendLocalPacketList.audio[0].packetsLost;
              let recentlyAllAudioPacket =
                this.sendLocalPacketList.audio[parketAudioListLength - 1]
                  .allpacket - this.sendLocalPacketList.audio[0].allpacket;
              audiolostpacketrate = parseInt(
                (recentlyPacketAudioLost / recentlyAllAudioPacket) * 100
              );
              if (audiolostpacketrate <= 0) {
                audiolostpacketrate = 0;
              } else if (audiolostpacketrate > 100) {
                audiolostpacketrate = 100;
              }
              if (this.sendLocalPacketList.audio.length > 20) {
                this.sendLocalPacketList.audio.splice(0, 1);
              }
            }
          }
        }
        this.sendLocalStatus = sendLocalStatus;
        if (this.sendLocalStatus && this.sendLocalStatus.video) {
          this.sendLocalStatus["video"]["lostpacketrate"] = videolostpacketrate;
          this.sendLocalStatus["video"]["speedRate"] = videospeedRate;
          this.sendLocalStatus["video"]["packetsLosts"] = packetLocalVideoLost;
          this.setVideoData("sendLocalStatus");
        }
        if (this.sendLocalStatus && this.sendLocalStatus.audio) {
          this.sendLocalStatus["audio"]["speedRate"] = audiospeedRate;
          this.sendLocalStatus["audio"]["lostpacketrate"] = audiolostpacketrate;
          this.setAudioData("sendLocalStatus");
        }
        // 接收
        console.log(this.Subscription);
        console.log(this.Subscription, "testVideoData");
        console.log(this.liveStream, "testVideoData");
        if (this.liveStream && this.Subscription) {
          console.log(this.liveStream);
          let receiveStatus =
            await this.rtcClient.RTCRoom.webrtc.getReceiveStats(
              this.Subscription
            );
          if (
            this.receiveStatus &&
            this.receiveStatus.video &&
            receiveStatus.video
          ) {
            var videoLivespeedRate = null;
            console.log(
              receiveStatus.video.bytesReceived -
              this.receiveStatus.video.bytesReceived
            );
            if (receiveStatus.video.bytesReceived) {
              videoLivespeedRate = parseInt(
                ((receiveStatus.video.bytesReceived -
                  this.receiveStatus.video.bytesReceived) /
                  1024) *
                8
              );
              if (videoLivespeedRate <= 0) {
                videoLivespeedRate = 0;
              }
            }
          }
          if (
            this.receiveStatus &&
            this.receiveStatus.audio &&
            receiveStatus.audio
          ) {
            var audioLivespeedRate = null;
            if (receiveStatus.audio.bytesReceived) {
              audioLivespeedRate = parseInt(
                ((receiveStatus.audio.bytesReceived -
                  this.receiveStatus.audio.bytesReceived) /
                  1024) *
                8
              );
              if (audioLivespeedRate <= 0) {
                audioLivespeedRate = 0;
              }
            }
          }
          this.receiveStatus = receiveStatus;
          console.log(this.receiveStatus, 'receiveStatus');
          console.log(this.receiveStatus, "testVideoData1");
          if (this.receiveStatus && this.receiveStatus.video) {
            this.receiveStatus["video"]["speedRate"] = videoLivespeedRate;
            this.setVideoData("receiveStatus");
          }
          if (this.receiveStatus && this.receiveStatus.audio) {
            this.receiveStatus["audio"]["speedRate"] = audioLivespeedRate;
            this.setAudioData("receiveStatus");
          }
        }
      }, 1000);
    },
    setVideoData(info) {
      console.log(this.videoNetData, "testVideoData2");
      let data =
        info == "sendLocalStatus" ? this.videoNetData : this.resVideoNetData,
        Status =
          info == "sendLocalStatus"
            ? JSON.parse(JSON.stringify(this.sendLocalStatus))
            : JSON.parse(JSON.stringify(this.receiveStatus)),
        packetsStatus =
          info == "sendLocalStatus" ? "packetsSent" : "packetsReceived";
      data.forEach((item) => {
        if (item.key == "frameHeight") {
          item.value =
            Status["video"]["frameWidth"] +
            "*" +
            Status["video"]["frameHeight"];
        } else if (item.key == "lostpacketrate") {
          item.value = Status["video"]["nackCount"]
            ? Status["video"]["nackCount"] / Status["video"][`${packetsStatus}`]
            : 0;
          item.value = parseInt(item.value * 100);
        } else {
          item.value = Status["video"][item.key]
            ? Status["video"][item.key]
            : 0;
        }
      });
      console.log(this.videoNetData, "testVideoData3");
      this.logger.info({ code: 2021, message: data })
    },
    setAudioData(info) {
      let data =
        info == "sendLocalStatus" ? this.audioNetData : this.resAudioNetData,
        Status =
          info == "sendLocalStatus" ? this.sendLocalStatus : this.receiveStatus,
        packetsStatus =
          info == "sendLocalStatus" ? "packetsSent" : "packetsReceived";
      data.forEach((item) => {
        if (item.key == "googCodecName") {
          item.value = "opus";
        } else if (item.key == "lostpacketrate") {
          item.value = Status["audio"]["nackCount"]
            ? Status["audio"]["nackCount"] / Status["audio"][`${packetsStatus}`]
            : 0;
          item.value = parseInt(item.value * 100);
        } else {
          item.value = Status["audio"][item.key]
            ? Status["audio"][item.key]
            : 0;
        }
      });
      this.logger.info({ code: 2022, message: data })
    },
    closeSet() {
      clearInterval(this.timer);
      this.timer = null;
      this.sendLocalPacketList = {
        video: [],
        audio: [],
      };

      this.sendLocalStatus = null;
      this.receiveStatus = null;
    },
  },
};
</script>

<style  scoped lang="scss">
.netstatus-container {
  width: 500px;

  .netstatus-list {
    display: inline-block;
    width: 200px;
    vertical-align: top;
    margin-bottom: 20px;
    text-align: left;
  }
}
</style>
